import { put } from 'redux-saga/effects';
import { errorHandler } from 'src/errorHandler/errorHandler';
import { logUiErrorToBackend } from 'src/utils/logUiErrorToBackend';
import {
    GET_PRODUCT_DETAILS_SUCCESS,
    GET_PRODUCT_DETAILS_ERROR,
    SORT_PRODUCT_DETAILS,
} from '../actions/actionTypes';
import { sortSetItemDetails } from 'src/utils/util';
import { getProductDetailsDataService } from '../../services';
import { getProductDetailsApiEndpoint } from '../../services/endpoints';

export default function* getProductDetails(action) {
    const { productCFN, salesOrg, orderType, resourceType } = action.payload;
    
    try {
        const result = yield getProductDetailsDataService(encodeURIComponent(productCFN), salesOrg, orderType, resourceType);
        yield put({ type: GET_PRODUCT_DETAILS_SUCCESS, payload: result });
        const isSetDetails = resourceType
            ?.split(',')
            .includes('BILL_OF_MATERIALS');
        const object = {
            data: result?.productDetails,
            searchField: isSetDetails ? 'bom' : 'cfn',
            ascending: true,
        };
        const param = isSetDetails ? 'billOfMaterials' : 'foundInSets';
        const sortedProducts = sortSetItemDetails({
            ...object,
            objectField: param,
        },isSetDetails);
        const sortedData = {
            ...result?.productDetails,
            [param]: sortedProducts,
        };
        yield put({
            type: SORT_PRODUCT_DETAILS,
            payload: sortedData,
        });
    } catch (e) {
        logUiErrorToBackend(e, {
            apiEndPoint: getProductDetailsApiEndpoint(encodeURIComponent(productCFN), encodeURIComponent(salesOrg), encodeURIComponent(orderType), encodeURIComponent(resourceType)),
            requestPayload: action.payload
        });
        yield put({
            type: GET_PRODUCT_DETAILS_ERROR,
            payload: errorHandler('503'),
        });
    }
}
